<template>
  <l-cache ref="cache" :get-data="getItem" :id="this.$route.query.id">
    <reservation-info :authority="auth" slot-scope="{data}" :reservation="data">
      <template slot="title-actions">
        <v-btn flat color="primary" class="mx-0" @click="$refs.cache.retry()">刷新</v-btn>
        <!--<v-btn flat color="primary" class="mx-0" @click="goReservationGroup(data)">查看分组</v-btn>-->
      </template>
    </reservation-info>
  </l-cache>
</template>

<script>
import ReservationInfo from '../Common/reservationInfo'

export default {
  name: 'OrgReservationDetails',
  components: {ReservationInfo},
  computed: {
    auth () {
      return this.$store.state.reservation.orgAuth
    }
  },
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('reservation/getReservations', {
        pagination: {},
        search: {key: 'id', value: key},
        locate: this.$route.query.history ? 'history' : 'runtime'
      })
      if (items.length) {
        try {
          let des = JSON.parse(items[0].description).comment
          items[0].description = des
        }
        catch (e) {

        }
        return items[0]
      }
      else {
        throw Error('未找到该预约')
      }
    }
    // goReservationGroup (item) {
    //   if (item.groupId) {
    //     this.$router.push({
    //       name: 'ReservationGroupDetails',
    //       params: {id: item.groupId},
    //     })
    //   }
    //   else {
    //     this.$L.alert('success snackbar', '分组未设置')
    //   }
    // },
  }
}
</script>

<style scoped>

</style>
